export const GET_REDEMPTION_REQUEST = 'GET_REDEMPTION_REQUEST';
export const GET_REDEMPTION_SUCCESS = 'GET_REDEMPTION_SUCCESS';
export const GET_REDEMPTION_FAILED = 'GET_REDEMPTION_FAILED';

export const CREATE_REDEMPTION_REQUEST = 'CREATE_REDEMPTION_REQUEST';
export const CREATE_REDEMPTION_SUCCESS = 'CREATE_REDEMPTION_SUCCESS';
export const CREATE_REDEMPTION_FAILED = 'CREATE_REDEMPTION_FAILED';

export const UPDATE_REDEMPTION_REQUEST = 'UPDATE_REDEMPTION_REQUEST';
export const UPDATE_REDEMPTION_SUCCESS = 'UPDATE_REDEMPTION_SUCCESS';
export const UPDATE_REDEMPTION_FAILED = 'UPDATE_REDEMPTION_FAILED';

export const DELETE_REDEMPTION_REQUEST = 'DELETE_REDEMPTION_REQUEST';
export const DELETE_REDEMPTION_SUCCESS = 'DELETE_REDEMPTION_SUCCESS';
export const DELETE_REDEMPTION_FAILED = 'DELETE_REDEMPTION_FAILED';

export const CLEAR_REDEMPTION = 'CLEAR_REDEMPTION';
